import * as React from 'react';
import { connect } from 'react-redux';
import * as AlertModule from 'Modules/AlertModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import { withTranslation  } from 'react-i18next';
import * as Dictionary from 'Models/Dictionary';
import { ActionDetailsIcon } from 'HelperFunctions/DetailsSidebarHelpers';
import { submit } from 'redux-form';

type P = {
    history?: any;
    edit: boolean;
    match?: any;
};
type ConnectedP = {
    alertStore: AlertModule.Types.AlertStore;
};
type DispatchedP = {
    deleteAlert: (alertId: number) => void;
    setActiveAlert: (alert: AlertModule.Types.AlertDefinitionDto) => void;
    showPopup: (popupData: ViewManagementModule.Types.Popup) => void;
    t?: (key: string) => string;
    alertFormSubmit: () => void;
};
type S = {};

class ManageAlertDetails extends React.Component<P & ConnectedP & DispatchedP, S> {
    constructor(props: P & ConnectedP & DispatchedP) {
        super(props);
    }

    private manageDeleteClick() {
        const { alertStore, showPopup, deleteAlert } = this.props;
        const { PopupType } = ViewManagementModule.VMEnumTypes;
        if (alertStore.activeAlert) {
            showPopup({
                type: PopupType.DELETE_ALERT,
                confirmCallback: async () => {
                    await deleteAlert(alertStore.activeAlert.id);
                    this.props.setActiveAlert(null);
                    this.props.history.push(ViewManagementModule.EnumTypes.Page.ALERTS);
                }
            });
        }
    }

    public render() {
        const { t } = this.props;
        return (
            <div className="details-right__dashboard">
                <ActionDetailsIcon active iconSrc={`/images/icons/save.svg`} title={t('forms:saveAlert')} onClick={() => this.props.alertFormSubmit()} />
                {this.props.match.params.alertId !== 'add' && <ActionDetailsIcon active={true} iconSrc={`/images/icons/garbage.svg`} title={t('delete')} onClick={() => this.manageDeleteClick()} />}
                <ActionDetailsIcon
                    active
                    iconSrc={`/images/icons/addSign.svg`}
                    title={t('forms:cancel')}
                    rotate
                    onClick={() => this.props.history.push(Dictionary.PageUrl.get(ViewManagementModule.EnumTypes.Page.ALERTS))}
                />
            </div>
        );
    }
}

function mapStateToProps(state: any): ConnectedP {
    return {
        alertStore: state.alertStore
    };
}
function mapDispachToProps(dispatch: any): DispatchedP {
    return {
        deleteAlert: alertId => dispatch(AlertModule.Actions.deleteAlert(alertId)),
        setActiveAlert: (alert: AlertModule.Types.AlertDefinitionDto) => dispatch(AlertModule.Actions.setActiveAlert(alert)),
        showPopup: (popupData: ViewManagementModule.Types.Popup) => dispatch(ViewManagementModule.Actions.showPopup(popupData)),
        alertFormSubmit: () => dispatch(submit('AddAlert'))
    };
}
export default withTranslation (['carDetails', 'forms'])(
    connect(
        mapStateToProps,
        mapDispachToProps
    )(ManageAlertDetails) as React.ComponentType<any>
);



// WEBPACK FOOTER //
// ./src/components/Layout/DetailsSidebar/ManageAlertDetails.tsx